import { core } from "./core";
import { leave } from "./leave";
import { notifications } from "./notifications";
import { email } from "./email";
import { ui } from "./ui";
import { home } from "./home";
import { expenses } from "./expenses";
import { lifecycle } from "./lifecycle";
import { documents } from "./documents";
import { comms } from "./comms";
import { data } from "./data";
import { platform } from "./platform";

export const tr = {
  ...core,
  leave,
  notifications,
  email,
  ui,
  home,
  expenses,
  lifecycle,
  documents,
  comms,
  data,
  platform,
};
